import { Component, OnInit } from "@angular/core";
import { ConfirmationService } from "primeng/api";
import { DialogService } from "primeng/dynamicdialog";
import { UserService } from "../../../shared";
import { BusAlertTypeModifyComponent } from "./bus-alert-type-modify/bus-alert-type-modify.component";
import { DataService_BusTrackerAlertType } from "./shared/data.service";

@Component({
	selector: "app-bus-alert-type-maintenance",
	templateUrl: "./bus-alert-type-maintenance.component.html",
	styleUrls: ["./bus-alert-type-maintenance.component.css"],
})
export class BusAlertTypeMaintenanceComponent implements OnInit {
	constructor(
		private userService: UserService,
		private AlertTypeService: DataService_BusTrackerAlertType,
		private dialogService: DialogService,
		private confirmationService: ConfirmationService
	) {}

	//INSERT ON INIT HERE
	ngOnInit(): void {
		this.user = this.userService.getCurrentUser();

		this.loadAlertType();
	}

	////////////////////////////////////////////
	// Data
	////////////////////////////////////////////

	Processing: any = false;

	ToggleText: any = "Deactivate Alert Type";

	///////////////
	// Built-In
	///////////////

	user: any;
	pagerows: any = 10;
	pagefirst: any = 0;
	loading: any = false;
	errorMessage: any = "";

	///////////////

	///////////////
	// Custom
	///////////////

	//Main
	SelectedAlertType: any;
	lstAlertType: any = [];

	//Filter lists
	lstSeverityDesc: any = [];
	lstActiveDesc: any = [];
	lstDefinedByDesc: any = [];

	//Cols
	cols: any = [
		//INSERT CUSTOM COLUMNS HERE
		{ field: "AlertTypeCD", header: "Code" },
		{ field: "AlertTypeDesc", header: "Description" },
		{ field: "SeverityDesc", header: "Severity" },
		// { field: 'ActiveDesc', header: 'Active' },
	];

	///////////////

	////////////////////////////////////////////

	////////////////////////////////////////////
	// Load Data
	////////////////////////////////////////////

	loadAlertType() {
		this.errorMessage = "";

		this.loading = true;

		var result = this.AlertTypeService.AlertTypeSelectAll();
		result.subscribe(
			(response) => {
				this.lstAlertType = response;

				//Load Data Filter Lists
				this.lstSeverityDesc = Array.from(new Set(this.lstAlertType.map((item: any) => item.SeverityDesc))).sort();
				this.lstActiveDesc = Array.from(new Set(this.lstAlertType.map((item: any) => item.ActiveDesc))).sort();
				this.lstDefinedByDesc = Array.from(new Set(this.lstAlertType.map((item: any) => item.DefinedByDesc))).sort();

				this.loading = false;
			},
			(error) => {
				this.loading = true;
			}
		);
	}

	////////////////////////////////////////////

	////////////////////////////////////////////
	// Buttons
	////////////////////////////////////////////

	onRefresh() {
		this.loadAlertType();
	}

	//Custom Button Methods
	onAdd() {
		this.errorMessage = "";

		var ref = this.dialogService.open(BusAlertTypeModifyComponent, {
			header: "Add Alert type",
			width: "fit-content",
			data: {
				//INSERT Custom Data here
				EditMode: false,
			},
		});
		ref.onClose.subscribe((response) => {
			if (response == 1) {
				this.onRowUnselect(null);
				this.loadAlertType();
			}
		});
	}

	onEdit() {
		this.errorMessage = "";

		if (this.SelectedAlertType == undefined) {
			this.errorMessage = "Select an alert type to edit";
			return;
		}

		if (this.SelectedAlertType.DefinedByID <= 2 && this.user.userID != 0) {
			this.errorMessage = "Only a system administrator can edit system-defined or import-defined alert types";
			return false;
		}

		var ref = this.dialogService.open(BusAlertTypeModifyComponent, {
			header: "Edit Alert Type",
			width: "fit-content",
			data: {
				//INSERT Custom Data here
				EditMode: true,
				AlertTypeID: this.SelectedAlertType.AlertTypeID,
				Severity: this.SelectedAlertType.Severity,
				AlertTypeCD: this.SelectedAlertType.AlertTypeCD,
				AlertTypeDesc: this.SelectedAlertType.AlertTypeDesc,
			},
		});
		ref.onClose.subscribe((response) => {
			if (response == 1) {
				this.onRowUnselect(null);
				this.loadAlertType();
			}
		});
	}

	onToggle() {
		this.errorMessage = "";

		//Error handling
		if (this.SelectedAlertType == undefined) {
			this.errorMessage = "Select an alert type to toggle";
			return;
		}

		if (this.SelectedAlertType.DefinedByID <= 2 && this.user.userID != 0) {
			this.errorMessage = "Only a system administrator can edit system-defined or import-defined alert types";
			return false;
		}

		//Call SP
		this.Processing = true;

		var changeTo = this.SelectedAlertType.Active == true ? 0 : 1;

		var result = this.AlertTypeService.AlertTypeToggle(this.SelectedAlertType.AlertTypeID, changeTo);
		result.subscribe(
			(response) => {
				if (response) {
					this.onRowUnselect(null);
					this.loadAlertType();
				} else {
					var MSG = "";

					if (changeTo == 1) {
						MSG = "Could not activate the alert type";
					} else {
						MSG = "Could not deactivate the alert type";
					}

					//
					// Error message
					//
					this.confirmationService.confirm({
						key: "main",
						acceptLabel: "Ok",
						rejectVisible: false,
						message: MSG,
						header: "ERROR",
						icon: "fa",
						accept: () => {},
					});
				}

				this.Processing = false;
			},
			(error) => {
				this.Processing = false;
			}
		);
	}

	onDelete() {
		this.errorMessage = "";

		//Error handling
		if (this.SelectedAlertType == undefined) {
			this.errorMessage = "Select an alert type to delete";
			return;
		}

		if (this.SelectedAlertType.DefinedByID <= 2 && this.user.userID != 0) {
			this.errorMessage = "Only a system administrator can delete system-defined or import-defined alert types";
			return false;
		}

		//
		// Check if the alert type is in use
		//
		this.AlertTypeInUse();
	}

	AlertTypeInUse() {
		this.Processing = true;

		var result = this.AlertTypeService.AlertTypeInUse(this.SelectedAlertType.AlertTypeID);
		result.subscribe(
			(response) => {
				if (response) {
					this.confirmationService.confirm({
						key: "main",
						acceptLabel: "Ok",
						rejectVisible: false,
						message:
							"Alert Type already in use. Delete alerts created by the school and delete alerts created by buses before deleting this alert type.",
						header: "ERROR",
						icon: "fa",
						accept: () => {},
					});
				} else {
					this.ConfirmDelete();
				}

				this.Processing = false;
			},
			(error) => {
				this.Processing = false;
			}
		);
	}

	ConfirmDelete() {
		this.confirmationService.confirm({
			key: "confirmdelete",
			acceptLabel: "Yes",
			rejectLabel: "No",
			rejectVisible: true,
			message: "Are you sure you want to delete this alert type?",
			header: "Confirm Delete Alert Type",
			icon: "fa",
			accept: () => {
				this.FinishDelete();
			},
			reject: () => {
				this.Processing = false;
			},
		});
	}

	FinishDelete() {
		var result = this.AlertTypeService.AlertTypeDelete(this.SelectedAlertType.AlertTypeID);
		result.subscribe(
			(response) => {
				if (response) {
					this.onRowUnselect(null);
					this.loadAlertType();
				} else {
					this.confirmationService.confirm({
						key: "main",
						acceptLabel: "Ok",
						rejectVisible: false,
						message: "Could not delete the Alert Type.",
						header: "ERROR",
						icon: "fa",
						accept: () => {},
					});
				}

				this.Processing = false;
			},
			(error) => {
				this.Processing = false;
			}
		);
	}

	////////////////////////////////////////////

	////////////////////////////////////////////
	// Events
	////////////////////////////////////////////
	onHandleFilter(val) {}
	onHandleSort(val) {}
	onRowSelect(val) {
		this.errorMessage = "";

		this.SelectedAlertType = val.data;

		this.ToggleText = "Deactivate Alert Type";
		if (this.SelectedAlertType.Active == false) {
			this.ToggleText = "Activate Alert Type";
		}
	}
	onRowUnselect(val) {
		this.errorMessage = "";

		this.SelectedAlertType = null;

		this.ToggleText = "Deactivate Alert Type";
	}
	onRowDblClick(AlertType) {
		this.errorMessage = "";

		this.SelectedAlertType = AlertType;

		this.ToggleText = "Deactivate Alert Type";
		if (this.SelectedAlertType.Active == false) {
			this.ToggleText = "Activate Alert Type";
		}

		this.onEdit();
	}
	////////////////////////////////////////////

	////////////////////////////////////////////
	// Helpers
	////////////////////////////////////////////

	IsLoading() {
		return this.loading == true || this.Processing == true;
	}

	CanEdit() {
		if (this.SelectedAlertType == undefined) {
			return false;
		}
		if (this.user == undefined) {
			return false;
		}
		if (this.SelectedAlertType.DefinedByID <= 2 && this.user.userID != 0) {
			return false;
		}

		return true;
	}

	////////////////////////////////////////////
}
